import React, { useEffect, useState } from "react";
import TableContainer from "../../../Component/TableContainer";
import { Box, Checkbox, IconButton, Switch, Typography } from "@mui/material";
import { Link, useSearchParams } from "react-router-dom";
import { useSelector } from "react-redux";
import {
  CheckCircle,
  DeleteOutline,
  EditOffOutlined,
  EditOutlined,
  RadioButtonUncheckedOutlined,
} from "@mui/icons-material";
import { color } from "../../../StyleData/Config";

import { eventSample } from "../../../SampleData/EventSample";
import ShiftEventModal from "./ShiftEventModal";

import ResponsiveDialog from "../../../Component/ResponsiveDialog";
const ShiftEventList = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const actionsAllow = useSelector((state) => state.dataRed.actionsAllow);

  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState(eventSample);
  const [create, setCreate] = useState(false);
  const [mode, setMode] = useState("");
  const [editData, setEditData] = useState({});
  const [filterValue, setFilterValue] = useState("enableData");
  const [backUpData, setBackUpData] = useState([]);

  //   useEffect(() => {
  //     getData();
  //   }, []);

  //   const getData = async() => {
  //     setIsLoading(true);
  //     const link = masterAPI["assetCategory"].link;
  //    await axiosPrivate
  //       .get(`${link}`)
  //       .then((res) => {
  //         res.data.result.sort((a, b) => {
  //           return a.code.localeCompare(b.code, undefined, {
  //             numeric: true,
  //             sensitivity: 'base'
  //           });
  //         });
  //         if(filterValue==="enableData"){
  //           const filterDataResult=res.data.result.filter(fil=>fil.isActive)
  //           console.log(filterDataResult, "locationresult");
  //           setData(filterDataResult);
  //           setBackUpData(res.data.result)
  //         }else{
  //           setData(res.data.result)
  //           setBackUpData(res.data.result)
  //         }
  //         setIsLoading(false);
  //       })
  //       .catch((e) => {
  //         console.log(e, "assetCategory");
  //         setIsLoading(false);
  //         setData([])
  //         setBackUpData([])
  //       });
  //   };

  const handleButtonNew = () => {
    // setMode("Create");
    // setCreate(true);
  };
  const handleCreate=()=>{
    setCreate(true)
  }
  const handleCreateClose = () => {
    setMode("");
    setCreate(false);
    // getData();
  };

//   const handleEdit = (data) => {
//     setEditData(data);
//     setMode("Edit");
//     setCreate(true);
//   };

const columns = [
  {
    Header: "Event Code",
    accessor: "Notification_key",
     Cell: ({ cell }) => {
            return (
              <Typography
                sx={{
                  color: "#0d6efd",
                  textDecorationLine: "underline",
                  fontWeight: 800,
                  cursor: "pointer",
                  fontSize:"inherit"
                }}
                onClick={handleCreate}
              >
                {cell.value}
              </Typography>
            );
          },
  },
  
  {
    Header: "Event name",
    accessor: "Notification_name",
  },

    {
      Header: "Priority",
      accessor: "Priority",
    },
 
    {
      Header: "Status",
      accessor: "Status",
    },
    {
      Header: "Shift resp area key",
      accessor: "Shift_resp_area_key",
    },
    {
      Header: "Done",
      accessor: "Done",
    },
    // {
    //   Header: "Notification type key",
    //   accessor: "Notification_type_key",
    // },
    {
      Header: "Location",
      accessor: "Position_key",
    },
    {
      Header: "Asset Code",
      accessor: "Maint_object_key",
    },
    {
      Header: "Reported by",
      accessor: "Reported_by",
    },
    {
      Header: "Order date time",
      accessor: "Order_date_time",
    },
    {
      Header: "Responsible",
      accessor: "Responsible",
    },
    {
      Header: "Work Order Code",
      accessor: "Work_order_key",
    },
    {
      Header: "Work order status",
      accessor: "Work_order_status",
    },
  
    {
      Header: "Shift ID",
      accessor: "Shift_ID",
    },
    {
      Header: "Extra Event Info",
      accessor: "Extra_notification_info",
    },
    {
      Header: "Document",
      accessor: "Document",
    },
    {
      Header: "Shift Code",
      accessor: "Site",
    },
    // {
    //   Header: "Legal unit key",
    //   accessor: "Legal_unit_key",
    // },
    // {
    //   Header: "Currency",
    //   accessor: "Currency",
    // },
    // {
    //   Header: "Plant_key",
    //   accessor: "Plant_key",
    // },
    // {
    //   Header: "Sour",
    //   accessor: "sour",
    // },
  ];
  const handleChangeFilter = (e) => {
    if (e === "showAll") {
      setData(backUpData);
    } else {
      const filterDataResult = backUpData.filter((fil) => fil.isActive);

      setData(filterDataResult);
    }
    setFilterValue(e);
  };

  return (
    <>
      <Box>
        <Typography
          sx={{
            color: color.masterPageTitleColor,
            fontSize: color.masterPageTitleFontSize,
            fontWeight: color.masterPageTitleFontWeight,
            mb: color.masterPageTitlemd,
          }}
        >
          Shift Events
        </Typography>
      </Box>

      <TableContainer
        columns={columns}
        data={data}
          buttonNew={handleButtonNew}
        loading={isLoading}
        buttonDisable={!actionsAllow.create}
        //   filterValue={filterValue}
        //   handleChange={handleChangeFilter}
        filterShow={false}
        display={"notVisible"}
      />

      <ResponsiveDialog
        open={create}
        onClose={handleCreateClose}
        maxWidth={"md"}
        children={
          <ShiftEventModal
            handleCloseClick={handleCreateClose}
            mode={mode}
            editData={editData}
          />
        }
      />
    </>
  );
};

export default ShiftEventList;
